import React from "react";
import messages from "components/messagesDescription";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { intlShape, injectIntl } from "react-intl";
import Plans from "./OtherBenefitPlans";
import UpArrow from "../../../common/ArrowUp";
import DownArrow from "../../../common/ArrowDown";
import { toggleShowMore } from "../../../../actions/otherBenefitsActions";
import { Card } from "cxa-components";
import MiniPlans from "./MiniPlans";

const OtherBenefits = ({ intl, data }) => {
  const dispatch = useDispatch();
  return (
    <div className="product-panel">
      {data.map(account => (
        <div className="panel-head" key={account.accountId}>
          {account.otherBenefits.map((benefit, benefitIndex) => (
            <Card key={`${account.accountId}-${benefitIndex}`}>
              <div className="panel-container">
                <div className="benefit-name-container">
                  <strong>
                    {intl.formatMessage({ id: benefit.name, defaultMessage: benefit.name })}
                  </strong>
                  <button
                    className="link"
                    onClick={() => dispatch(toggleShowMore(account.accountId, benefit.id))}
                  >
                    <span style={{ marginLeft: "5px" }}>
                      {benefit.showMore ? (
                        <UpArrow width="14px" height="14px" />
                      ) : (
                        <DownArrow width="16px" height="16px" />
                      )}
                    </span>
                  </button>
                </div>

                <div>
                  <p>
                    {intl.formatMessage({
                      id: benefit.description,
                      defaultMessage: benefit.description,
                    })}
                  </p>
                  <p>
                    {intl.formatMessage(messages.otherBenefits.quotedPrices)}{" "}
                    <strong>{account.accountCurrency}</strong>
                  </p>
                  {benefit.members.map((member, memberIndex) => (
                    <div
                      key={`${account.accountId}-${benefit.name}-${member.memberName}-${memberIndex}`}
                    >
                      <div>
                        <p>
                          <strong>
                            {intl.formatMessage(messages.otherBenefits.selectionName)}{" "}
                            {member.memberName}
                          </strong>
                        </p>
                      </div>
                      {member && benefit.showMore ? (
                        <Plans account={account} benefit={benefit} member={member} />
                      ) : (
                        <MiniPlans member={member} />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      ))}
    </div>
  );
};

OtherBenefits.propTypes = {
  intl: PropTypes.shape(intlShape).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default injectIntl(OtherBenefits);



// WEBPACK FOOTER //
// ./components/employee/shop/other-benefits/OtherBenefits.js